import React, { Children, PropsWithChildren, ReactElement } from 'react';
import { Grid } from '../grid/Grid';
import { Cell } from '../grid/Cell';

export const List = ({ children, gap }: Props) => (
    <Grid direction='column' gap={gap}>
        {Children.map(children as ReactElement[], c => (
            <Cell> {c} </Cell>
        ))}
    </Grid>
);

type Props = PropsWithChildren<{
    gap?: Parameters<typeof Grid>[0]['gap']
}>;
